<img
        [src]="path"
        alt="Logo"
        class="image"

>
